import React from 'react'
import './distributorsandretailers.scss'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonTabs, FigureCards, NewsCard, Faq, SuccessStories, CommonBlueCards } from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const DistributorsRetailers = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/who-we-serve/" },
    { label: "Retailer and distributor insurance", link: "/whoweserve/distributorsandretailers"},
  ];

  const HeaderData = [
    {
      image: images['Guidance_Telescope_Blue.svg'],
      para: 'As a distributor or retailer, certain aspects of your business need special attention and protection. With high volumes of inventory, a long distribution chain, or crowds of customers, we recognize that a one-size-fits-all solution may not be best for your company. Whether you’re self-employed or working at a company with thousands of employees, we can help protect your distribution or retail business with customized insurance solutions.',
      para1: 'Are you a national accounts broker or part of a large business looking for loss-sensitive program options? We offer specialized services for national accounts and brokers.',
    },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Distributors and wholesalers',
      description:
        'We understand your business faces unique risks. From your warehouse to the products in transit, see how we can help you protect your distribution business.',
      linkUrl: '',
      linkText: 'More about distributor insurance  >',
    },
    {
      id: 2,
      title: 'Retailers',
      description:
        'With tight profit margins, every dollar counts in the retail industry. We’re dedicated to protecting your company while helping you save money.',
      linkUrl: '/',
      linkText: 'More about retailer insurance >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Distributor and retailer resources',
      description:
        'Explore our resources, featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  const tabsData = [
    {
      id: "thesentry",
      href: "#/",
      label: "The Sentry difference",
    },
    {
      id: "weserve",
      href: "#/",
      label: "Who we serve",
    },
  ];
  const activeTabId = "thesentry";
  return (
    <>
      <div className='dealership-main'>
        {/* hero section */}
        <Hero img={images["retailersanddistributorsHero.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Insurance for distributors and retailers" showshare={false} />

          {/* tabs */}
          <CommonTabs tabs={tabsData} activeTab={activeTabId} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} />

          <div className='the-sentry'>
            <Row className='g-0'>
              <Col sm={12} md={4} lg={4} xl={4}>
                <div className='img-wrapper'>
                  <img src={images['Dealerships-SentryDifference.avif']} alt="img" />
                </div>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8}>
                <div className='details-section'>
                  <h1>The Sentry difference</h1>
                  <h2>Keeping your business running</h2>
                  <p>When you choose Sentry, you’ll be working with our knowledgeable, in-house claims team, who have experience in your industry. When you file a claim, we’ll work to take care of the details of your claim accurately and efficiently, so you can keep moving your business forward.</p>
                  <div className='trust-bottom'>
                    <img src={images['birds_Blue.svg']} alt="icon" />
                    <div className='text'>
                      <h3>We’re here when you need us</h3>
                      <p>Contact us by phone, fax, or online. We’re ready for you 24/7.</p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* dealerships we serve */}
          <NewsCard Title="Who we serve" CardData={ProductCardData} showNavLink={false} subTitle=" " />

          {/* stories */}
          <SuccessStories />

          {/* common blue cards  */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default DistributorsRetailers